export default "__VITE_ASSET__CfnTPwlJ__"